import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Phone, Mail, MapPin, Download } from 'lucide-react';

const Footer = () => {
  const { t } = useTranslation();

  const quickLinks = [
    { path: '/', label: t('navbar.home') },
    { path: '/about', label: t('navbar.about') },
    { path: '/products', label: t('navbar.products') },
    { path: '/projects', label: t('navbar.projects') }
  ];

  const services = [
    t('services.installation_title'),
    t('services.maintenance_title'),
    t('services.consultation_title'),
    t('services.spareparts_title')
  ];

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-blue-950 to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <div className="w-10 h-10 bg-gradient-to-br from-white to-gray-300 rounded-lg flex items-center justify-center shadow-lg">
                <img
                src="../images/CAJ-logo++.png"
                alt="Logo PT. Chandika Anugrah Jaya"
                className="w-10 h-10 object-contain"
                />
              </div>
              <div className="font-bold text-lg">{t('footer.about_title')}</div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              {t('footer.about_text')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-lg mb-4">{t('footer.quick_links')}</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-white transition-colors duration-300 text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-bold text-lg mb-4">{t('footer.services_title')}</h3>
            <ul className="space-y-2">
              {services.map((service, index) => (
                <li key={index} className="text-gray-400 text-sm">
                  {service}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-bold text-lg mb-4">{t('contact.info_title')}</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-blue-400 flex-shrink-0 mt-0.5" />
                <span className="text-gray-400 text-sm">{t('contact.address')}</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="h-5 w-5 text-blue-400 flex-shrink-0" />
                <a
                  href={`tel:${t('contact.phone')}`}
                  className="text-gray-400 hover:text-white transition-colors duration-300 text-sm"
                >
                  {t('contact.phone')}
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="h-5 w-5 text-blue-400 flex-shrink-0" />
                <a
                  href={`mailto:${t('contact.email')}`}
                  className="text-gray-400 hover:text-white transition-colors duration-300 text-sm"
                >
                  {t('contact.email')}
                </a>
              </li>
            </ul>
          </div>
          {/* Legalitas */}
          <div>
            <h3 className="font-bold text-lg mb-4">Legalitas</h3>
            <ul className="space-y-3">
              <li>
                <a
                  href="/files/Kebijakan Privasi.pdf"
                  download="Kebijakan Privasi.pdf"
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center space-x-2 text-gray-300 bg-blue-900/30 hover:bg-blue-800/50 px-3 py-2 rounded-lg transition-colors duration-300 text-sm border border-blue-800/50 w-full"
                >
                  <Download className="h-4 w-4 flex-shrink-0" />
                  <span>Kebijakan Privasi</span>
                </a>
              </li>
              <li>
                <a
                  href="/files/Syarat Layanan.pdf"
                  download="Syarat Layanan.pdf"
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center space-x-2 text-gray-300 bg-blue-900/30 hover:bg-blue-800/50 px-3 py-2 rounded-lg transition-colors duration-300 text-sm border border-blue-800/50 w-full"
                >
                  <Download className="h-4 w-4 flex-shrink-0" />
                  <span>Syarat Layanan</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-500 text-sm">{t('footer.copyright')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;